export const account = {
  initial: 'idle',
  states: {
    idle: {
      always: [
        {
          target: 'on',
          cond: 'isKrakenEnabled',
        },
        {
          target: 'off',
        },
      ],
    },
    on: {
      invoke: {
        src: 'watchAccountActions',
      },
      on: {
        VIEW_PROMOTIONS_EVENT_CALLED: {
          actions: 'openPromotionsPage',
        },
        APP_VISIBILITY_VISIBLE: {
          actions: 'updateBalance',
        },
      },
    },
    off: {},
  },
};
